import React, { useEffect, useState } from 'react';
import { SOCKET_CLIENT } from '../../../../../utils/socket';
import { useNavigate, useParams } from 'react-router-dom';
import { getChat, getChatUsers, getRoomId } from '../../../services/chat.services';
import { getUser } from '../../../../../utils/commonfunction';
import { ROLE } from '../../../../../utils/Constants';
import Messages from './Messages';
import { useTranslation } from 'react-i18next';

export default function Chat() {
  const { t } = useTranslation();
  const params = useParams();
  const navigate = useNavigate();
  const [roomId, setRoomId] = useState("")
  const SENDER = getUser(ROLE.PSYCHIC);
  
  const [newMessage, setNewMessage] = useState('');
  const [chatUsers, setChatUsers] = useState([]);

  useEffect(() => {
    getChatUsers()
      .then((response) => {
        console.log("=-==users List-=-=-", response)
        setChatUsers(response?.data?.list);
      })
      .catch((error) => {
        console.log("error", error)
      })
  }, []);

  function onUserClick(receiver){
    if(receiver.chatDetails && receiver.chatDetails._id){
      navigate(`/psychic/chat/${receiver.chatDetails._id}?receiverID=${receiver._id}`, {state: {receiver: receiver}});
    }else{
      getRoomId({receiverId: receiver._id, senderId: SENDER._id,})
      .then((response) => {
        console.log("=-=chatId=->", response);
        navigate(`/psychic/chat/${response.data._id}?receiverID=${receiver._id}`, {state: {receiver: receiver}});
      })
    }
    //   setRoomId(receiver.roomId)
    //   setRoomId(receiver?.chatDetails?._id)
  }

  console.log("-=-=-=-roomId--=-=-=-=", roomId);

  return (
    <div className='dashboard-right-container'>
      <div className='dashboard-header'>
        <h2 className='heading-22-bold'>{t("label_chat_history")}</h2>
      </div>
      <div className='dashboard-body'>
        <div className='chat-wrapper'>
          <div className='chat-left-container'>
            <div className='chat-search-box'>
              <input type='text' placeholder='Search' />
              <button aria-label="Search"><i className='ti ti-search' aria-hidden="true"></i></button>
            </div>
            <div className='chat-list-box' tabindex={0}>
              {/* Recent chats */}
              {chatUsers?.map((receiver) => (
                <div onClick={() => onUserClick(receiver)} className='chat-list-item d-flex gap-3' key={receiver._id}>
                  <figure className='avatar avatar-md m-0'>
                    <img alt='avatar' src={receiver.profile_image} />
                  </figure>
                  <figcaption>
                    <h4 className='heading-18-semibold'>{receiver.name}</h4>
                    <p className='m-0'>{receiver.designation}</p>
                    <span>{t("chat_welcome_what_would_you_like_to_discuss_today")}</span>
                  </figcaption>
                </div>
              ))}
            </div>
          </div>
          {
            params.roomID ?
              <Messages/>
            :
            <>
              <div className='py-5 text-center w-100 mt-5'>
                <h4>{t("chat_welcome")}</h4>
              </div>
            </>
          }
        </div>
      </div>
    </div>
  )
}
